import { j as o } from "../../jsx-runtime-ClSzPYp4.js";
import { styled as i } from "styled-components";
import s from "../../Header/Header.mjs";
import { SCREEN_WIDTHS as a } from "../../common/themes/constants/constants.mjs";
import f, { defaultBrandConfig as m } from "../BrandedLogo/BrandedLogo.mjs";
const p = /* @__PURE__ */ i.div.withConfig({
  componentId: "sc-e63eff46-0"
})([
  "",
  ""
], ({ theme: r }) => r.components.header.contentWrapper), c = () => /* @__PURE__ */ o.jsx(f, {
  brandConfig: m
}), l = ({ Logo: r = c, bordered: e, maxWidth: n = a.EIGHT_COLUMN, children: t, ...d }) => /* @__PURE__ */ o.jsx(s, {
  bordered: e,
  maxWidth: n,
  ...d,
  children: /* @__PURE__ */ o.jsxs(p, {
    children: [
      /* @__PURE__ */ o.jsx(r, {}),
      t
    ]
  })
});
export {
  l as default
};
